import { datadogRum } from '@datadog/browser-rum';
export default function datadogInit() {
    if (import.meta.env.CLIENT_ENVIRONMENT !== 'local') {
    datadogRum.init({
        applicationId: '9cb96592-7b9c-4d71-a87c-45f782e0d522',
        clientToken: 'pubd06442c0a6ca4d73bda818ac7618c8ef',
        site: 'us3.datadoghq.com',
        service: 'da-great-plains-client',
        env: import.meta.env.CLIENT_NODE_ENV,
        version: __APP_VERSION__, // dynamically replaced by vite at build time.
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'mask-user-input',
    });
    }
}